module.exports = __webpack_public_path__ + "img/bg_affiliates.b8745d05.png";